import script from "./MyRegistrations.vue?vue&type=script&setup=true&lang=js"
export * from "./MyRegistrations.vue?vue&type=script&setup=true&lang=js"

import "./MyRegistrations.vue?vue&type=style&index=0&id=4fd12aea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fd12aea"]])

export default __exports__